import { render, staticRenderFns } from "./uploadImgJavam.vue?vue&type=template&id=402ab7bd&"
import script from "./uploadImgJavam.vue?vue&type=script&lang=js&"
export * from "./uploadImgJavam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports